import{useContext}from"react";import{JutroThemeContext}from"../Contexts";export const useTheme=()=>useContext(JutroThemeContext);